import React, { useContext, useState } from "react";

import { Drawer } from "@material-ui/core";

import { bright_90, increaseBrightness } from "external/helpers/adjustColor";
import { getMenuLinks } from "external/helpers/getFooterLinks";
import configSelector from "external/store/selectors/configSelector";
import pageSelector from "external/store/selectors/pageSelector";
import upsdkSelector from "external/store/selectors/upsdkSelector";
import { BaseContext } from "../../context/BaseContext";
import LanguageHelper from "external/helpers/language.helper";
import BookmarkIcon from "../../assets/icons/bookmark.icon";
import ProfileIcon from "../../assets/icons/profile-dark.icon";
import FAQIcon from "../../assets/icons/faq.icon";
import LogoutIcon from "../../assets/icons/logout.icon";
import OrderNowIcon from "../../assets/icons/order-now.icon";
import PastOrdersIcon from "../../assets/icons/past-order.icon";
import ReferAndEarnIcon from "../../assets/icons/referearn.icon";
import SettingsIcon from "../../assets/icons/settings.icon";
import WalletMenuIcon from "../../assets/icons/wallet-menu.icon";
import LanguageIcon from "../../assets/icons/languages.icon";
import AppStoreDownloadIcon from "../../assets/images/AppStore.svg";
import PlayStoreDownloadIcon from "../../assets/images/PlayStore.svg";
import { useDialog } from "../../context/DialogContext";
import CurrencyHelper from "external/helpers/currency.helper";
import AppButton from "../button/index.component";
import SelectField from "../fields/select-field/index.component";
import Typography from "../typography/index.component";
import ScreenHelper from "../../helpers/screen.helper";
import useRouteHook from "../../hooks/useRoute.hook";
import { connect } from "react-redux";

import "./index.component.scss";

function SideBar(props) {
  // callbacks
  const {
    t,
    i18n,
    location,
    toggleDrawerCallback,
    userLogoutCallback,
    showAuthDialogCallback,
    customRoutes,
    upsdk,
    isMobileView,
  } = props;

  // props
  const {
    open,
    userData,
    primaryColor,
    primaryTextColor,
    secondaryTextColor,
    authToken,
    secondaryColor,
    config,
    guestUser,
  } = props;
  const { CustomNavLink } = useRouteHook();
  const { showDialog, hideDialog } = useDialog();
  const initialLanguage = LanguageHelper.getLanguage(config);
  const isGuestLogin = guestUser?.name && guestUser?.phone;

  const [languageDropdownState, setChangeLanguageDropdown] = useState(false);
  const [activeLan, setActiveLanguage] = useState(initialLanguage);

  // variables
  const walletConfig = configSelector.getWalletConfig({ config });
  const menuPageConfig = pageSelector.getMenuPage({ config });
  const profilePageConfig = pageSelector.getProfilePage({ config });
  const referEarnPageConfig = pageSelector.getReferEarnPage({ config });
  const referEarnBool = configSelector.getReferralBool({ config });
  const orderHistoryPageConfig = pageSelector.getOrderHistoryPage({ config });
  const favouritePageConfig = pageSelector.getFavouritesPage({ config });
  const supportedLanguages = upsdkSelector.getSupportedLanguages({ upsdk });
  const leftLink = configSelector.getTopHeaderLeftLink({ config });
  const customMenuLinks = getMenuLinks(
    configSelector.getCustomPages({ config }),
  );
  const externalPageLinks = configSelector.getExternalPageLinks({ config });
  const { menuRoute, landingScreenEnabled, isQrModeEnabled, isQsrEnabled } =
    useContext(BaseContext);

  const handleOnConfirm = () => {
    userLogoutCallback();
    hideDialog();
    toggleDrawerCallback();
  };

  const handleUserLogout = () => {
    showDialog({
      title: t("common.confirm"),
      buttonText: t("common.ok"),
      buttonColor: primaryColor,
      description: t("common.logoutAlert"),
      onClickCallback: () => handleOnConfirm(),
    });
  };

  const handleLoginClick = () => {
    showAuthDialogCallback("signIn");
    toggleDrawerCallback();
  };

  // const handleSignUpClick = () => {
  //   showAuthDialogCallback("signUp");
  //   toggleDrawerCallback();
  // };

  const toggleChangeLanguageDropdown = () => {
    setChangeLanguageDropdown(!languageDropdownState);
  };

  const onLanguageChangeHandler = (language) => {
    LanguageHelper.onLanguageChange(i18n, language);
    setActiveLanguage(language);
  };

  const UserInfo = () => (
    <div className="user-info-section">
      <div className="default-avatar" style={{ backgroundColor: primaryColor }}>
        {userData ? (
          <Typography variant="h2" weight="bold" className="avatar-text">
            {userData.name.charAt(0) || ""}
          </Typography>
        ) : null}
      </div>
      {userData ? <User /> : <UserPlaceholder />}
    </div>
  );

  const User = () => (
    <div className="user-info">
      <Typography
        variant="h2"
        weight="bold"
        className="user-name"
        fontColor={primaryTextColor}
      >
        {userData.name}
      </Typography>
      <Typography
        variant="h3"
        weight="regular"
        className="user-mobile"
        fontColor={secondaryTextColor}
      >
        {userData.phone}
      </Typography>
    </div>
  );

  const UserPlaceholder = () => (
    <div className="user-info">
      <Typography
        variant="h3"
        weight="bold"
        className="user-name"
        fontColor={primaryTextColor}
        onClickCallback={handleLoginClick}
      >
        {t("sidebar.login")}
      </Typography>
      <Typography
        variant="h4"
        weight="regular"
        className="user-mobile"
        fontColor={secondaryTextColor}
      >
        {t("sidebar.loggedOutStateMessage")}
      </Typography>
    </div>
  );

  const DownloadApp = () => (
    <div className="downloadApp-btn-wrapper">
      {leftLink.iOSAppLink && (
        <a
          target="_blank"
          rel="noreferrer"
          href={leftLink.iOSAppLink}
          className="download-app-link"
        >
          <img
            src={AppStoreDownloadIcon}
            alt="app-store"
            className="download-btn app-store"
          />
        </a>
      )}
      {leftLink.androidAppLink && (
        <a
          target="_blank"
          rel="noreferrer"
          href={leftLink.androidAppLink}
          className="download-app-link"
        >
          <img
            src={PlayStoreDownloadIcon}
            className="download-btn play-store"
            alt="app-store"
          />
        </a>
      )}
    </div>
  );

  const ChangeLanguageDropdown = () => (
    <SelectField
      name="changeLanguage"
      open={languageDropdownState}
      defaultValue={initialLanguage}
      primaryTextColor={primaryTextColor}
      iconBackgroundColor={increaseBrightness(secondaryColor, bright_90)}
      options={supportedLanguages.map((lang, index) => {
        return { title: lang.toUpperCase(), value: lang };
      })}
      onChange={(event) => {
        onLanguageChangeHandler(event.target.value);
      }}
      toggleTimeSlotDropdownCallback={toggleChangeLanguageDropdown}
      value={activeLan}
    />
  );

  const renderLanguageChanger = () =>
    supportedLanguages.length > 1 && (
      <div
        className="menu-item"
        activeStyle={{ backgroundColor: primaryColor }}
        activeClassName="active-menu-item"
        to="/past-orders"
      >
        <LanguageIcon
          className="menu-icon"
          fill={increaseBrightness(primaryColor, bright_90)}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <Typography
            className="menu-name"
            variant="h2"
            weight="regular"
            fontColor={secondaryTextColor}
          >
            {t("sidebar.changeLanguage")}
          </Typography>
          {ChangeLanguageDropdown()}
        </div>
      </div>
    );

  if (!authToken) {
    return (
      <Drawer
        classes={{ paper: "side-bar-wrapper" }}
        anchor={i18n.dir() === "rtl" ? "right" : "left"}
        open={open}
        onClose={toggleDrawerCallback}
      >
        <div className="container">
          <div>
            {isGuestLogin ? (
              <UserInfo />
            ) : (
              <div className="login-alert-section">
                <div className="profile-icon-wrapper">
                  <ProfileIcon className="field-icon" />
                </div>
                <div className="login-content">
                  <Typography
                    className="user-account-heading"
                    variant="h2"
                    weight="semibold"
                  >
                    {t("sidebar.userAccount")}
                  </Typography>
                  <Typography
                    className="user-account-text"
                    variant="h3"
                    weight="regular"
                  >
                    {t("sidebar.loginDescription")}
                  </Typography>

                  <div className="button-wrapper">
                    <AppButton
                      fullWidth
                      variant="contained"
                      className="login-button"
                      buttonColor={primaryColor}
                      onClickCallback={handleLoginClick}
                    >
                      <Typography
                        variant="h3"
                        weight="bold"
                        fontColor="#FFFFFF"
                      >
                        {t("sidebar.loginNow")}
                      </Typography>
                    </AppButton>
                  </div>
                </div>
              </div>
            )}

            <div className="menu-list no-auth">
              {isMobileView && renderLanguageChanger()}
              {customMenuLinks && customMenuLinks.length
                ? customMenuLinks.map((customMenu) => (
                    <CustomNavLink
                      className="menu-item"
                      activeStyle={{ backgroundColor: primaryColor }}
                      activeClassName="active-menu-item"
                      to={customMenu.path}
                      key={customMenu._id}
                    >
                      <FAQIcon
                        className="menu-icon"
                        fill={
                          ScreenHelper.isCustomScreen(
                            location.pathname,
                            customMenu.path,
                          )
                            ? "#FFFFFF"
                            : increaseBrightness(primaryColor, bright_90)
                        }
                      />
                      <Typography
                        className="menu-name"
                        variant="h2"
                        weight="regular"
                        fontColor={
                          ScreenHelper.isCustomScreen(
                            location.pathname,
                            customMenu.path,
                          )
                            ? "#FFFFFF"
                            : secondaryTextColor
                        }
                      >
                        {customMenu.name}
                      </Typography>
                    </CustomNavLink>
                  ))
                : null}
              {externalPageLinks && externalPageLinks.length
                ? externalPageLinks.map((link) => (
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="menu-item"
                      key={link.id}
                    >
                      <FAQIcon
                        className="menu-icon"
                        fill={
                          ScreenHelper.isCustomScreen(
                            location.pathname,
                            link.url,
                          )
                            ? "#FFFFFF"
                            : increaseBrightness(primaryColor, bright_90)
                        }
                      />
                      <Typography
                        className="menu-name"
                        variant="h2"
                        weight="regular"
                        fontColor={
                          ScreenHelper.isCustomScreen(
                            location.pathname,
                            link.url,
                          )
                            ? "#FFFFFF"
                            : secondaryTextColor
                        }
                      >
                        {link.name}
                      </Typography>
                    </a>
                  ))
                : null}
              {isGuestLogin && (
                <div className="menu-item" onClick={handleUserLogout}>
                  <LogoutIcon
                    className="menu-icon"
                    fill={increaseBrightness(primaryColor, bright_90)}
                  />
                  <Typography
                    className="menu-name"
                    variant="h2"
                    weight="regular"
                    fontColor={secondaryTextColor}
                  >
                    {t("sidebar.logout")}
                  </Typography>
                </div>
              )}
            </div>
          </div>
          {!isQsrEnabled ? (
            (leftLink.iOSAppLink || leftLink.androidAppLink) &&
            isMobileView && <DownloadApp />
          ) : (
            <div>{/* empty div for spacing */}</div>
          )}
        </div>
      </Drawer>
    );
  }

  return (
    <Drawer
      classes={{ paper: "side-bar-wrapper" }}
      anchor={i18n.dir() === "rtl" ? "right" : "left"}
      open={open}
      onClose={toggleDrawerCallback}
    >
      <UserInfo />
      <div className="menu-list">
        {!isMobileView && menuPageConfig.enabled && (
          <CustomNavLink
            /**
             * the below condition in exact makes sure the menu tab is highlighted on
             * every category and subcategory as well.
             */
            exact={
              !ScreenHelper.isMenuScreen(
                customRoutes,
                location.pathname,
                landingScreenEnabled,
              )
            }
            className="menu-item"
            style={
              ScreenHelper.isMenuScreen(
                customRoutes,
                location.pathname,
                landingScreenEnabled,
              )
                ? { backgroundColor: primaryColor }
                : {}
            }
            activeClassName="active-menu-item"
            to={menuRoute}
            check={true}
          >
            <OrderNowIcon
              className="menu-icon"
              fill={
                ScreenHelper.isMenuScreen(
                  customRoutes,
                  location.pathname,
                  landingScreenEnabled,
                )
                  ? "#ffffff"
                  : increaseBrightness(primaryColor, bright_90)
              }
            />
            <Typography
              className="menu-name"
              variant="h2"
              weight="regular"
              fontColor={
                ScreenHelper.isMenuScreen(
                  customRoutes,
                  location.pathname,
                  landingScreenEnabled,
                )
                  ? "#FFFFFF"
                  : secondaryTextColor
              }
            >
              {t("sidebar.menu")}
            </Typography>
          </CustomNavLink>
        )}
        {orderHistoryPageConfig.enabled && (
          <CustomNavLink
            className="menu-item"
            activeStyle={{ backgroundColor: primaryColor }}
            activeClassName="active-menu-item"
            to="/past-orders"
          >
            <PastOrdersIcon
              className="menu-icon"
              fill={
                ScreenHelper.isPastOrdersScreen(location.pathname)
                  ? "#ffffff"
                  : increaseBrightness(primaryColor, bright_90)
              }
            />
            <Typography
              className="menu-name"
              variant="h2"
              weight="regular"
              fontColor={
                ScreenHelper.isPastOrdersScreen(location.pathname)
                  ? "#FFFFFF"
                  : secondaryTextColor
              }
            >
              {t("sidebar.pastOrders")}
            </Typography>
          </CustomNavLink>
        )}

        {favouritePageConfig.enabled && (
          <CustomNavLink
            className="menu-item"
            activeStyle={{ backgroundColor: primaryColor }}
            activeClassName="active-menu-item"
            to="/favourites"
          >
            <BookmarkIcon
              className="menu-icon"
              fill={
                ScreenHelper.isFavouritesScreen(location.pathname)
                  ? "#ffffff"
                  : increaseBrightness(primaryColor, bright_90)
              }
            />
            <Typography
              className="menu-name"
              variant="h2"
              weight="regular"
              fontColor={
                ScreenHelper.isFavouritesScreen(location.pathname)
                  ? "#FFFFFF"
                  : secondaryTextColor
              }
            >
              {t("common.favorites")}
            </Typography>
          </CustomNavLink>
        )}
        {walletConfig.enable && (
          <CustomNavLink
            className="menu-item"
            activeStyle={{ backgroundColor: primaryColor }}
            activeClassName="active-menu-item"
            to="/wallet"
          >
            <WalletMenuIcon
              className="menu-icon"
              fill={
                ScreenHelper.isWalletScreen(location.pathname)
                  ? "#FFFFFF"
                  : increaseBrightness(primaryColor, bright_90)
              }
            />
            <Typography
              className="menu-name"
              variant="h2"
              weight="regular"
              fontColor={
                ScreenHelper.isWalletScreen(location.pathname)
                  ? "#FFFFFF"
                  : secondaryTextColor
              }
            >
              {t("sidebar.walletBalance")}
            </Typography>
            {userData && (
              <Typography
                variant="h2"
                weight="regular"
                className="menu-badge"
                style={{
                  backgroundColor: ScreenHelper.isWalletScreen(
                    location.pathname,
                  )
                    ? "#FFFFFF"
                    : primaryColor,
                }}
                fontColor={
                  ScreenHelper.isWalletScreen(location.pathname)
                    ? primaryColor
                    : "#FFFFFF"
                }
              >
                {CurrencyHelper.format(userData.balance)}
              </Typography>
            )}
          </CustomNavLink>
        )}
        {referEarnPageConfig.enabled && referEarnBool && (
          <CustomNavLink
            className="menu-item"
            activeStyle={{ backgroundColor: primaryColor }}
            activeClassName="active-menu-item"
            to="/refer-and-earn"
          >
            <ReferAndEarnIcon
              className="menu-icon"
              fill={
                ScreenHelper.isReferAndEarnScreen(location.pathname)
                  ? "#ffffff"
                  : increaseBrightness(primaryColor, bright_90)
              }
            />
            <Typography
              className="menu-name"
              variant="h2"
              weight="regular"
              fontColor={
                ScreenHelper.isReferAndEarnScreen(location.pathname)
                  ? "#FFFFFF"
                  : secondaryTextColor
              }
            >
              {t("sidebar.referEarn")}
            </Typography>
          </CustomNavLink>
        )}
        {!isQsrEnabled && profilePageConfig.enabled && (
          <CustomNavLink
            className="menu-item"
            activeStyle={{ backgroundColor: primaryColor }}
            activeClassName="active-menu-item"
            to="/profile"
          >
            <SettingsIcon
              className="menu-icon"
              fill={
                ScreenHelper.isProfileScreen(location.pathname)
                  ? "#FFFFFF"
                  : increaseBrightness(primaryColor, bright_90)
              }
            />
            <Typography
              className="menu-name"
              variant="h2"
              weight="regular"
              fontColor={
                ScreenHelper.isProfileScreen(location.pathname)
                  ? "#FFFFFF"
                  : secondaryTextColor
              }
            >
              {t("sidebar.profile")}
            </Typography>
          </CustomNavLink>
        )}
        {customMenuLinks && customMenuLinks.length
          ? customMenuLinks.map((customMenu) => (
              <CustomNavLink
                className="menu-item"
                activeStyle={{ backgroundColor: primaryColor }}
                activeClassName="active-menu-item"
                to={customMenu.path}
              >
                <FAQIcon
                  className="menu-icon"
                  fill={
                    ScreenHelper.isCustomScreen(
                      location.pathname,
                      customMenu.path,
                    )
                      ? "#FFFFFF"
                      : increaseBrightness(primaryColor, bright_90)
                  }
                />
                <Typography
                  className="menu-name"
                  variant="h2"
                  weight="regular"
                  fontColor={
                    ScreenHelper.isCustomScreen(
                      location.pathname,
                      customMenu.path,
                    )
                      ? "#FFFFFF"
                      : secondaryTextColor
                  }
                >
                  {customMenu.name}
                </Typography>
              </CustomNavLink>
            ))
          : null}
        {externalPageLinks && externalPageLinks.length
          ? externalPageLinks.map((link) => (
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="menu-item"
              >
                <FAQIcon
                  className="menu-icon"
                  fill={
                    ScreenHelper.isCustomScreen(location.pathname, link.url)
                      ? "#FFFFFF"
                      : increaseBrightness(primaryColor, bright_90)
                  }
                />
                <Typography
                  className="menu-name"
                  variant="h2"
                  weight="regular"
                  fontColor={
                    ScreenHelper.isCustomScreen(location.pathname, link.url)
                      ? "#FFFFFF"
                      : secondaryTextColor
                  }
                >
                  {link.name}
                </Typography>
              </a>
            ))
          : null}
        {isMobileView && renderLanguageChanger()}
        {userData && (
          <div className="menu-item" onClick={handleUserLogout}>
            <LogoutIcon
              className="menu-icon"
              fill={increaseBrightness(primaryColor, bright_90)}
            />
            <Typography
              className="menu-name"
              variant="h2"
              weight="regular"
              fontColor={secondaryTextColor}
            >
              {t("sidebar.logout")}
            </Typography>
          </div>
        )}
      </div>

      {!isQsrEnabled ? (
        (leftLink.iOSAppLink || leftLink.androidAppLink) &&
        isMobileView && <DownloadApp />
      ) : (
        <div>{/* empty div for spacing */}</div>
      )}
    </Drawer>
  );
}

const mapStateToProps = (state) => ({
  guestUser: state.auth.data,
});

export default connect(mapStateToProps)(SideBar);
